import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { BreathAPIs } from "../APIs/BreathAPIs";
import PageNotFound from "../PageNotFound/PageNotFound";
import "./UserProfile.css";
import { Button, Select, Switch, Radio, Image } from "antd";
import { toast, ToastContainer } from "react-toastify";
import store from "../store";
import { loadUser } from "../Actions/Auth";
import { ButtonCustom } from "../BootstrapComponents/ButtonCustom";
import PhoneVerificationModal from "../RegistrationCommponents/PhoneVerificationModal";
import { Tooltip, Modal } from "antd";
import StripePayment from "./StripePayment.js";
import TooltipView from "../Dashboard/components/AdminDashboard/TooltipView";
import PhoneInput from "../components/PhoneInput";
import CardBlock from "../CardBlock/CardBlock.jsx";
import { useStripe } from "@stripe/react-stripe-js";
import { addAmount } from "../Actions/Auth";
import { useDispatch } from "react-redux";
import NACS_IMAGE from "../Images/nacs.png";
import J1772_IMAGE from "../Images/j1772.png";
// import type { CollapseProps } from 'antd';
import { Collapse } from "antd";
import CardPaymentForm from "./CardPaymentForm.js";
import { FaExternalLinkAlt } from "react-icons/fa";
// import { Navigate } from 'react-router';
import { useNavigate } from "react-router-dom";
import { useWebSocket } from "../Utils/WebSocketContext";
import { Alert, Input } from "antd";
import { AiOutlineDelete } from "react-icons/ai";
import { CiEdit } from "react-icons/ci";
import { IoEyeOutline } from "react-icons/io5";
import { MdOutlineQrCodeScanner } from "react-icons/md";
import QRCodeScanner from "../components/QRCodeScanner";
import {
  extractLocationCodeFromScan,
  isValidLocationCode,
} from "../Utils/locationCode";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";

const UserProfile = (props) => {
  const [showOverNightChargingCredits, setShowOverNightChargingCredits] =
    useState(
      props.location.some((loc) => {
        return loc.overNightChargingEnabled === true;
      }),
    );

  const [isLoading, setIsLoading] = useState(false);
  const [rfidLoading, setRfidLoading] = useState({
    locationChargersLoading: false,
    stepsLoading: false,
    rfidEditLoading: false,
    rfidDeleteLoading: false,
  });
  const [removedLocation, setRemovedLocation] = useState([]);
  const [autoPay, setAutopay] = useState(props.isAutoPayEnabled);

  const [noOfMethods, setNoOfMethods] = useState(0);
  const [userNRBookings, setUserNRBookings] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isPhoneVerified, setIsPhoneVerified] = useState(props.isPhoneVerified);
  const [savedPhoneState, setSavedPhoneState] = useState(
    props.isPhoneVerified ? props.phone : null,
  );
  const [showRfidRegUI, setShowRfidRegUI] = useState(false);
  const [isRfidRegModelOpen, setIsRfidRegModelOpen] = useState(false);
  const [rfidSelectedLocation, setRfidSelectedLocation] = useState(null);
  const [rfidSelectedCharger, setRfidSelectedCharger] = useState(null);
  const [rfidLocationChargers, setRfidLocationChargers] = useState([]);
  const [showTimeoutWarning, setShowTimeoutWarning] = useState(false);
  const [showActiveIdTag, setShowActiveIdTag] = useState(false);
  const [amountLoader, setAmountLoader] = useState(false);
  const [loadingTag, setLoadingTag] = useState(null);
  const [topUpAmountChangeConfirmation, setTopUpAmountChangeConfirmation] =
    useState(false);
  const [disableAutoPayConfirmation, setDisableAutoPayConfirmation] =
    useState(false);
  const [autoPayAmountAlert, setAutoPayAmountAlert] = useState(false);
  // const [showNameInputField, setShowNameInputField] = useState(false)
  const [userActiveIdTags, setUserActiveIdTags] = useState(props.userTags);
  const [showRfidNameInput, setShowRfidNameInput] = useState(false);
  const [userPreferredConnector, setUserPreferredConnector] = useState(
    props.userPreferredConnector,
  );
  const [prefConnectorConfirmation, setPrefConnectorConfirmation] =
    useState(false);
  const [editRfid, setEditRfid] = useState({
    idTag: null,
    idTagName: "",
    isModelOpen: false,
  });

  const [deleteRfid, setDeleteRfid] = useState({
    idTag: null,
    idTagName: "",
    isModelOpen: false,
  });

  const [rfidRegStatus, setRfidRegStatus] = useState({
    status: null,
    message: null,
  });

  const [latestVersions, setLatestVersions] = useState({
    webApp: null,
    csms: null,
  });

  const webSocket = useWebSocket();

  const checkOverNightEnabledInPublic = async () => {
    const res = await BreathAPIs.checkOverNightEnabledInPublic();
    // console.log("res for overnight: ", res)
    if (res.status === 200) {
      setShowOverNightChargingCredits(res.data.msg);
    }
    
  };

  const checkShowRfidRegUI = async ()=>{
    const response = await BreathAPIs.checkShowRfidRegUI();
    if (response.status === 200) {
      setShowRfidRegUI(response.data.showRfidRegUI);
    }
  }

  const fetchLatestVersions = async () => {
    try {
      const [webAppRes, csmsRes] = await Promise.all([
        BreathAPIs.getSoftwareVersionList(1, 1, "webApp"),
        BreathAPIs.getSoftwareVersionList(1, 1, "csms"),
      ]);
      setLatestVersions({
        webApp: webAppRes.data?.softwareVersionList?.[0]?.softwareVersion || null,
        csms: csmsRes.data?.softwareVersionList?.[0]?.softwareVersion || null,
      });
    } catch (error) {
      console.log("Error fetching latest software versions: ", error);
    }
  };

  useEffect(() => {
    let nightChargeEnabledInUserLoc = props.location.some((loc) => {
      return loc.overNightChargingEnabled === true;
    });
    if (nightChargeEnabledInUserLoc === false) {
      checkOverNightEnabledInPublic();
    }
    checkShowRfidRegUI();
    fetchLatestVersions();
  }, [props.location]);

  // useEffect(()=>{
  //     store.dispatch(loadUser())
  // })

  useEffect(() => {
    setUserActiveIdTags(props.userTags);
  }, [props.userTags]);

  useEffect(() => {
    if (webSocket) {
      webSocket.addEventListener("message", function (event) {
        if (JSON.parse(event.data).type === "rfid-auth") {
          setRfidRegStatus({
            status: JSON.parse(event.data).status,
            message: JSON.parse(event.data).message,
          });

          if (JSON.parse(event.data).status === "time-out") {
            setIsRfidRegModelOpen(false);
            setRfidSelectedLocation(null);
            setRfidSelectedCharger(null);
            setRfidLocationChargers([]);
            setRfidRegStatus({
              status: null,
              message: null,
            });
            setShowTimeoutWarning(true);
          }

          if (JSON.parse(event.data).status === "active") {
            setIsRfidRegModelOpen(false);
            setRfidSelectedLocation(null);
            setRfidSelectedCharger(null);
            setRfidLocationChargers([]);
            setRfidRegStatus({
              status: "active",
              message: null,
            });
            setShowActiveIdTag(true);
            setShowRfidNameInput(true);
            // store.dispatch(loadUser())
            setEditRfid({
              idTag: null,
              idTagName: "",
              isModelOpen: false,
            });
          }

          if (JSON.parse(event.data).status === "error") {
            setIsRfidRegModelOpen(false);
            setRfidSelectedLocation(null);
            setRfidSelectedCharger(null);
            setRfidLocationChargers([]);
            setRfidRegStatus({
              status: null,
              message: null,
            });
            store.dispatch(loadUser());
            setEditRfid({
              idTag: null,
              idTagName: "",
              isModelOpen: false,
            });
          }
        }

        // if (JSON.parse(event.data).type === "chargestation.online") {
        //   if (chargerId === JSON.parse(event.data).data.connectors[0].rate.meta_data.breatheID) {
        //     setChargerStatus("Online")
        //   }
        // }
        //{isTrusted: true, data: '{"type":"rfid-auth","status":"","message":""}', origin: 'wss://api.breathe-ev.dev', lastEventId: '', source: null, …}
      });
    } else {
    }
  }, [webSocket]);

  useEffect(() => {
    getUserCurrentBookings();
    if (userActiveIdTags.length > 0) {
      const lastTag = userActiveIdTags[userActiveIdTags.length - 1];
      if (lastTag.idTagStatus === "pre-auth") {
        setRfidRegStatus({
          status: "pre-auth",
          message: "Tap your RFID to start registration",
        });
        // setRfidSelectedLocation(null)
        setRfidSelectedCharger(lastTag.idTag);
      }
      if (lastTag.idTagStatus === "verification-pending") {
        setRfidRegStatus({
          status: "verification-pending",
          message: "Please tap the same RFID card to complete registration",
        });
      }
    }
  }, []);

  const updateUserRfid = async (idTag, idTagName) => {
    setRfidLoading({ ...rfidLoading, rfidEditLoading: true });
    try {
      const res = await BreathAPIs.updateUserRfid(idTag, idTagName);
      if (res.status === 200) {
        toast.success(res.data.message);
        store.dispatch(loadUser());
      }
    } catch (error) {
      console.log("error updating user rfid: ", error.message);
    } finally {
      setEditRfid({ idTag: null, idTagName: "", isModelOpen: false });
      setRfidLoading({ ...rfidLoading, rfidEditLoading: false });
    }
  };
  const deleteUserRfid = async (idTag) => {
    setRfidLoading({ ...rfidLoading, rfidDeleteLoading: true });
    try {
      const res = await BreathAPIs.deleteUserRfid(idTag);
      if (res.status === 200) {
        toast.success(res.data.message);
        store.dispatch(loadUser());
      }
    } catch (error) {
      console.log("error deleting user rfid: ", error.message);
    } finally {
      setRfidLoading({ ...rfidLoading, rfidDeleteLoading: false });
    }
  };

  const getRfidLocationChargers = async () => {
    try {
      const res =
        await BreathAPIs.getRfidLocationChargers(rfidSelectedLocation);
      setRfidLocationChargers(res.data.chargers);
    } catch (error) {
      console.log("error getting rfid location chargers: ", error.message);
      setRfidLocationChargers([]);
    } finally {
      setRfidLoading({ ...rfidLoading, locationChargersLoading: false });
    }
  };

  const updateRfidRegInCharger = async (type = "setUser") => {
    setIsRfidRegModelOpen(false);
    setRfidLoading({ ...rfidLoading, stepsLoading: true });
    try {
      if (rfidSelectedCharger) {
        const res = await BreathAPIs.updateRfidRegInCharger(
          rfidSelectedCharger,
          props.userID,
          type,
        );
        if (res.status == 200) {
          toast.success(
            res.data.message === "added"
              ? "Tap your RFID to start registration"
              : "Registration cancelled",
          );
          setRfidRegStatus(
            res.data.message === "added"
              ? {
                  status: "pre-auth",
                  message: "Tap your RFID to start registration",
                }
              : {
                  status: null,
                  message: null,
                },
          );
        } else {
          toast.error("Something went wrong please try again after some time");
        }
      }
    } catch (error) {
      console.log("error in update charger for rfid: ", error.message);
    } finally {
      setRfidLoading({ ...rfidLoading, stepsLoading: false });
    }
  };

  useEffect(() => {
    if (rfidSelectedLocation) {
      setRfidLoading({ ...rfidLoading, locationChargersLoading: true });
      getRfidLocationChargers();
    }
  }, [rfidSelectedLocation]);

  const updateWallet = (amount) => {
    dispatch(addAmount(amount));
  };

  const getUserCurrentBookings = async () => {
    const res = await BreathAPIs.getUpcomingBookings();

    res.data.map((b) => {
      if (b.user._id === props.userID) {
        //&& b.nonReservable
        setUserNRBookings([...userNRBookings, b]);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const locationsWithCode = location.filter((loc) => loc.codeId != null);

    const userProfile = {
      firstName: form.elements.firstName.value,
      lastName: form.elements.lastName.value,
      // email: form.elements.email.value?.toLowerCase(),
      phone: form.elements.phone.value,
      receive_sms_updates: form.elements.receive_sms_updates.checked,
      receive_promotional_messages: receive_promotional_messages,
      location: locationsWithCode.length ? locationsWithCode : [],
      defaultLocation: form.elements?.defaultLocation?.value
        ? form.elements?.defaultLocation?.value
        : null,
      timeFormatAmPm:
        form.elements.timeFormatAmPm.value == "am_pm" ? true : false,
      preferredConnector: userPreferredConnector,
      // only send company when a newly added location asked for one
      ...(companyOptions.length > 0 && { company }),
      // isAutoPayEnabled: res.data.paymentMethods === 0 ? false : form.elements.auto_reload.checked
    };

    removedLocation.map((rl) => {
      if (
        rl.locationType === "PRIVATE" &&
        String(localStorage.selectedLocation) === String(rl._id)
      ) {
        localStorage.removeItem("selectedLocation");
      }
    });
    //email validation
    // const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    // if (!emailRegex.test(userProfile.email)) {
    //     toast.error("Please enter a valid email address.");
    //     return;
    // }
    if (!isPhoneVerified) {
      toast.error("Please verify phone number to save changes", "warning");
      return;
    }
    if (companyOptions.length > 0 && !companyOptions.includes(company)) {
      toast.error("Please select your company");
      return;
    }
    if (
      form.elements.receive_sms_updates.checked &&
      (!/^\d+$/.test(form.elements.phone.value) ||
        (form.elements.phone.value.length !== 10 &&
          form.elements.phone.value.length !== 11))
    ) {
      toast.error("Must enter a valid phone number to receive SMS", "warning");
      return;
    }

    try {
      setIsLoading(true);
      const res = await BreathAPIs.updateProfile(userProfile);
      if (res) {
        if (res.data.success) {
          toast.success(res.data.message);
          store.dispatch(loadUser());
        } else {
          toast.error(res.data.message);
        }
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  const [location, setLocation] = useState(props.location);
  const [locationCode, setLocationCode] = useState("");
  const [company, setCompany] = useState(null);
  // companies offered by locations added in this session (not yet saved)
  const savedLocationIds = (props.location || []).map((loc) => String(loc?._id));
  const companyOptions = [
    ...new Set(
      (location || [])
        .filter((loc) => !savedLocationIds.includes(String(loc?._id)))
        .flatMap((loc) => loc?.companies || []),
    ),
  ];
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [isCheckingScannedCode, setIsCheckingScannedCode] = useState(false);
  const [isRedirectingToThirdParty, setIsRedirectingToThirdParty] = useState(false);

  const [phone, setPhone] = useState(props.phone);
  const previousPhone = props.phone;
  const [receive_sms_updates, setReceiveSMSUpdates] = useState(
    props.receive_sms_updates,
  );
  const previousReceiveSMS = props.receive_sms_updates;
  const [receive_promotional_messages, setReceivePromotionalMessages] =
    useState(props.receive_promotional_messages);

  const [defaultLocation, setDefaultLocation] = useState(props.defaultLocation);

  const [isPhoneNumberVerified, setIsPhoneNumberVerified] = useState(null);
  const [showPhoneVerificationModal, setShowPhoneVerificationModal] =
    useState(false);

  const [paymentModal, setPaymentModal] = useState(false);
  const [removeLocationConfirmation, setRemoveLocationConfirmation] =
    useState(null);
  const [methodList, setMethodList] = useState([]);

  const [activeKey, setActiveKey] = useState("1");
  const [selectedCard, setSelectedCard] = useState(props.selectedPayment);
  const [selectedCardDetails, setSelectedCardDetails] = useState({});

  const [toolTipView, setToolTipView] = useState(false);

  const tagsData = [20, 25, 30, 35];
  // console.log("auto pay threshold props: ", props.autoPayThreshold)

  const [selectedTags, setSelectedTags] = React.useState(
    props.autoPayThreshold,
  );

  const stripe = useStripe();

  const togglePanel = (key) => {
    if (activeKey === key) {
      // If the current key is being closed, keep it open
      return;
    }
    setActiveKey(key); // Set the new active panel
  };

  const handleCheckboxChange = async () => {
    try {
      setReceiveSMSUpdates(!receive_sms_updates);
      if (!receive_sms_updates) {
        let isPhoneUnique = await BreathAPIs.checkIfPhoneUnique(phone);
        if (!isPhoneUnique.data.ok) {
          toast.error("Phone already exists");
          setReceiveSMSUpdates(false);
        } else if (!/^\d+$/.test(phone) || !(phone.length === 10)) {
          toast.error(
            "Must enter a valid phone number to receive SMS",
            "warning",
          );
          setReceiveSMSUpdates(false);
        } else {
          if (!isPhoneVerified) {
            setShowPhoneVerificationModal(true);
            setReceiveSMSUpdates(false);
          } else {
            setReceiveSMSUpdates(true);
          }
        }
      }
    } catch (error) {
      toast.error("Please try again");
    }
  };
  const sanitizePhoneNumber = (input) => {
    const sanitized = input.replace(/\D/g, "");
    return sanitized.startsWith("1") ? sanitized.slice(1) : sanitized;
  };

  const handlePhoneNumberChange = (e) => {
    if (e.target.value === savedPhoneState) {
      setIsPhoneVerified(true);
      setReceiveSMSUpdates(true);
    } else if (e.target.value !== phone) {
      setIsPhoneVerified(false);
      setReceiveSMSUpdates(false);
    } else {
      setIsPhoneVerified(isPhoneVerified);
      setReceiveSMSUpdates(isPhoneVerified);
    }
    setPhone(sanitizePhoneNumber(e.target.value));
    if (e.target.value != previousPhone) {
      if (previousReceiveSMS) {
        setReceiveSMSUpdates(false);
      }
    }
  };

  const handleVerificationSuccess = () => {
    setReceiveSMSUpdates(true);
    setIsPhoneNumberVerified(true);
    setIsPhoneVerified(true);
    setSavedPhoneState(phone);
    toast.success("Phone number verified. Click Save button to Update");
  };

  const addLocation = async (codeOverride) => {
    const codeToAdd = codeOverride ?? locationCode;
    if (codeToAdd === "" || !isValidLocationCode(codeToAdd)) {
      toast.error("Invalid Location code. Please enter a valid location code.");
    } else {
      try {
        if (codeToAdd !== "") {
          const selLocation = await BreathAPIs.checkLocationCode(codeToAdd);
          setLocationCode("");
          if (!selLocation || selLocation.data.length === 0) {
            toast.error("Code is not valid");
          } else {
            if (selLocation.data.length === 1) {
              const firstLocation = selLocation.data[0];
              const isCodeExist = location.some(
                (apt) => apt.codeId === firstLocation.codeId,
              );

              if (!isCodeExist) {
                toast.success("Code valid. Click Save button to Update.");
                setLocation([...location, firstLocation]);
              } else {
                toast.warning("Code already exists in the list");
              }
            } else {
              // add locations that are not in user's location
              let filteredLocations = [];
              filteredLocations = selLocation.data.filter((locationData) => {
                return !location.some(
                  (apt) => apt.codeId === locationData.codeId,
                );
              });
              if (filteredLocations.length === 0) {
                toast.warning("Code already exists in the list");
              } else {
                toast.success("Code valid. Click Save button to Update.");
                setLocation([...location, ...filteredLocations]);
              }
            }
          }
        } else {
          setLocation([]);
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.error?.msg || "Code is not valid";
        toast.error(errorMessage);
      }
    }
  };

  const checkScannedLocationCode = async (code) => {
    setIsCheckingScannedCode(true);
    try {
      const selLocation = await BreathAPIs.checkLocationCode(code, { includeRedirectCode: true });
      const fetchedLocation = selLocation?.data?.[0];

      if (fetchedLocation?.enableThirdPartyRedirect && fetchedLocation?.thirdPartyRedirectUrl && fetchedLocation?.redirectCodeId === code) {
        setIsRedirectingToThirdParty(true);
        setTimeout(() => {
          window.location.href = fetchedLocation.thirdPartyRedirectUrl;
        }, 2000);
        return;
      }

      setIsCheckingScannedCode(false);
      setLocationCode(code);
      addLocation(code);
    } catch (error) {
      setIsCheckingScannedCode(false);
      const errorMessage = error.response?.data?.error?.msg || "Code is not valid";
      toast.error(errorMessage);
    }
  };

  const handleQRScan = (scannedText) => {
    const code = extractLocationCodeFromScan(scannedText);
    if (!isValidLocationCode(code)) {
      return false;
    }
    setShowQRScanner(false);
    checkScannedLocationCode(code);
    return true;
  };

  const handleRemoveLocation = (locationId, confirmed = false) => {
    console.log("removing location with id: ", location);
    const childLocations = location.filter((loc) => 
      loc.parentLocation 
      && loc.parentLocation.some((parentId) => parentId === locationId) 
      && loc.subLocationType === "CONDO");
    if (childLocations.length > 0 && !confirmed) {
      setRemoveLocationConfirmation({
        locationId,
        parentName: location.find((loc) => loc._id === locationId)?.locationName,
        childNames: childLocations.map((child) => child.locationName),
      });
      return;
    }
    let updatedLocations = location.filter((apt) => apt._id !== locationId);
    updatedLocations = updatedLocations.filter((apt) => !childLocations.some((child) => child._id === apt._id));
    setLocation(updatedLocations);
    let removedLocations = location.filter((l) => {
      return l._id === locationId;
    });
    removedLocations = location.filter((l) => {
      childLocations.forEach((child) => {
        if (child._id === l._id) {
          removedLocations.push(child);
        }
      });
      return l;
    });

    setRemovedLocation([...removedLocation, removedLocations[0]]);
  };

  const getStripePaymentMethods = async () => {
    try {
      const res = await BreathAPIs.getStripePaymentMethods(props.jwt, "card");
      setNoOfMethods(res.data.paymentMethods);
      return res;
    } catch (error) {
      console.log("Error getting payment number of payment methods", error);
    }
  };
  const handleDisableAutoPay = async () => {
    try {
      const autoPayRes = await BreathAPIs.updateAutoPaySetting(
        selectedTags,
        false,
      );
      store.dispatch(loadUser());
      setAutopay(!autoPay);
    } catch (error) {
      console.log("Error getting payment number of payment methods", error);
    }
  };
  const handleAutoReloadChange = async (e) => {
    try {
      console.log("auto pay```", e);
      if (!e) {
        setDisableAutoPayConfirmation(true);
        // const autoPayRes = await BreathAPIs.updateAutoPaySetting(selectedTags, e);
        // store.dispatch(loadUser())
      }

      // setPaymentModal(true)
      //fetch no of cardds for user in stripe

      if (e) {
        togglePanel("1");
        const res = await getStripePaymentMethods();
        setNoOfMethods(res.data.paymentMethods);
        setMethodList(res.data.methodList);
        res.data.methodList?.filter((card) => {
          if (card.id === selectedCard) {
            setSelectedCardDetails(card);
          }
        });

        //Check number of card payment methods available onclick
        // console.log(e.target.checked)
        if (e && !props.isAutoPayEnabled) {
          // res.data.paymentMethods === 0 && //!e.target.checked
          setPaymentModal(true);
          //If length is zero provide a payment for to enter card details
          //Stripe api and load stripe form
          // Debit 1usd from card and credit to user wallet
        }
        //call api to update user db

        setAutopay(!autoPay);
      }
    } catch (error) {}
  };

  const TooltipDisplay = () => {
    return (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: "0",
          marginTop: "8px",
        }}
      >
        <TooltipView
          text={
            <span>
              By enabling auto reload, we ensure that your wallet balance is
              always maintained at $5
            </span>
          }
          clsName={"profileFormStyle"}
        />
      </div>
    );
  };

  const addToTransactionHistory = async (amount, status, type) => {
    // console.log("need to add in trans his")
    setIsLoading(true);
    const res = await BreathAPIs.createTransactionHistory({
      dateEpoch: Math.floor(new Date().getTime() / 1000.0), // epoch value in GMT need to convert it into zone base
      amount: amount,
      status: status,
      type: type,
    });
    setIsLoading(false);
    // console.log(res.data)
  };

  function formatStripeError(errorString) {
    // Replace underscores with spaces
    let formattedString = errorString.replace(/_/g, " ");
    formattedString =
      formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
    return formattedString;
  }

  const sendPaymentIntent = async (paymentId) => {
    setIsLoading(true);
    try {
      // confirm payment from the front end with paymet.confirm
      if (!stripe) {
        return;
      }
      let amount =
        props.walletCoins < 5 ? Number(selectedTags) - props.walletCoins : 1;

      amount = amount <= 0.5 ? 1 : amount;
      const res = await BreathAPIs.addAmountFromCard(
        amount,
        paymentId,
        props.jwt,
      );
      const clientSecret = res.data.paymentIntent.client_secret;
      const { errors } = await stripe.confirmPayment({
        clientSecret,
        confirmParams: {
          return_url: process.env.REACT_APP_BASE_URL,
        },
        // Uncomment below if you only want redirect for redirect-based payments
        redirect: "if_required",
      });
      if (errors) {
        toast.error(formatStripeError(errors.code));
      } else {
        // console.log(selectedCardDetails)
        // updateUser payment method api
        const res = await BreathAPIs.updateProfile({
          isAutoPayEnabled: true,
          selectedPaymentMethod: selectedCard,
        });

        if (res.data.success) {
          updateWallet(amount);
          addToTransactionHistory(amount, "success", "Credit");
          toast.success(
            `Auto reload enabled on card ending with ${selectedCardDetails.card.last4}`,
          );
          togglePanel("1");
          setPaymentModal(false);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error in payment from card", error);
      setIsLoading(false);
    }
  };

  const handlePhoneNumberVerfiy = async () => {
    try {
      let isPhoneUnique = await BreathAPIs.checkIfPhoneUnique(phone);
      if (!isPhoneUnique.data.ok) {
        toast.error("Phone already exists");
      } else if (!/^\d+$/.test(phone) || !(phone.length === 10)) {
        toast.error("Must enter a valid phone number", "warning");
        // setReceiveSMSUpdates(false);
      } else {
        setShowPhoneVerificationModal(true);
      }
    } catch (error) {
      // console.log("Could not check phone number unique",error)
      toast.error("Please try again");
    }
  };


  if (props.isGuest) {
    return <PageNotFound />;
  }

  const handleChange = async (tag, checked) => {
    setAmountLoader(true);
    // console.log("auto pay tag change: ", tag, checked)
    try {
      let res = await BreathAPIs.updateAutoPaySetting(Number(tag));

      if (checked && res.data.success) {
        setSelectedTags(tag);
        toast.success("Wallet max amount updated");
      } else {
        setAutoPayAmountAlert(true);
        setTimeout(() => {
          setAutoPayAmountAlert(false);
        }, 5000);
      }
      setAmountLoader(false);
    } catch (error) {
      setAutoPayAmountAlert(true);
      setTimeout(() => {
        setAutoPayAmountAlert(false);
      }, 5000);
      setAmountLoader(false);
      console.log("error updating auto pay amount setting: ", error);
    }
  };

  return (
    <div>
      <div className="container mb-5 mb-md-6 mt-5">
        <ToastContainer></ToastContainer>
        <h2>My Profile</h2>
        <div className="justify-content-center">
          <form onSubmit={handleSubmit} className="user-profile">
            <div className="mb-3">
              <label className="form-label">First Name</label>
              <input
                required
                type="text"
                defaultValue={props.firstName}
                name="firstName"
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Last Name</label>
              <input
                required
                type="text"
                defaultValue={props.lastName}
                name="lastName"
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Email</label>
              {/* <input
                                required
                                type="text"
                                defaultValue={props.email}
                                name='email'
                                className="form-control"
                            /> */}
              <div className="form-control bg-warning">{props.email}</div>
            </div>

            <div className="mb-3">
              <label className="form-label">Phone</label>
              <div className="input-group flex-nowrap">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  +1
                </span>
                {
                  <PhoneInput
                    type="text"
                    value={phone}
                    placeholder="0000000000"
                    onChange={handlePhoneNumberChange}
                    name="phone"
                    className="form-control"
                  />
                }
                {phone && (
                  <span
                    className={`phone-number-status ${isPhoneVerified ? "verified" : ""}`}
                  >
                    {isPhoneVerified ? "Verified" : "Not-Verified"}
                  </span>
                )}
              </div>

              {showPhoneVerificationModal && (
                <PhoneVerificationModal
                  closeModal={() => setShowPhoneVerificationModal(false)}
                  onVerificationSuccess={handleVerificationSuccess}
                  modalVisible={showPhoneVerificationModal}
                  phoneNumber={phone}
                />
              )}
            </div>
            {
              <div
                className={`form-check ${isPhoneVerified ? "" : ""}`}
                style={{
                  opacity: isPhoneVerified ? "0" : "1",
                  transition: "all .4s",
                  visibility: isPhoneVerified ? "hidden" : "visible",
                  marginBottom: isPhoneVerified ? -20 : undefined,
                }}
              >
                <input
                  checked={isPhoneVerified}
                  name="verify-phone"
                  onChange={handlePhoneNumberVerfiy}
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="verifyCheckDefault"
                />
                <label
                  className="form-check-label"
                  htmlFor="verifyCheckDefault"
                >
                  Please verify your phone number.
                </label>
              </div>
            }

            <div className="form-check ">
              <input
                checked={receive_sms_updates}
                name="receive_sms_updates"
                onChange={handleCheckboxChange}
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefault"
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                I would like to receive updates on charging sessions via SMS
                messages.
              </label>
            </div>

            <div className="form-check mb-4">
              <input
                checked={receive_promotional_messages}
                className="form-check-input"
                type="checkbox"
                id="receive_promotional_messages"
                onChange={(e) =>
                  setReceivePromotionalMessages(e.target.checked)
                }
              />
              <label
                className="form-check-label"
                htmlFor="receive_promotional_messages"
              >
                Get BreatheEV offers & updates by SMS. Msg & data rates may
                apply. Reply STOP to opt out.
              </label>
            </div>

            {showOverNightChargingCredits && (
              <div className="charge-credits-container">
                <div className="charge-credits-label">
                  Overnight Charging Credits:
                </div>
                <div className="charge-credits-count">
                  <span className="charge-credits-available">
                    {props.availableNightChargeCount}
                  </span>
                  <span className="charge-credits-total">out of 4</span>
                </div>
              </div>
            )}

            {/* <label className="form-label">Payment
                            {
                                userNRBookings.length > 0 && props.isAutoPayEnabled &&
                                <span className='span_text'> ( Auto pay can be disablaed once bookings are completed )</span>
                            }
                        </label> */}

            {/* <div className="form-check mb-4" 
                        
                        >
                            <input
                                checked={autoPay} name='auto_reload'
                                onChange={(e) => handleAutoReloadChange(e)}
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckPayment"
                                disabled={userNRBookings.length > 0 && props.isAutoPayEnabled}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="flexCheckPayment"
                                onMouseEnter={() => setToolTipView(true)}
                                onMouseLeave={() => setToolTipView(false)}
                                onTouchStart={() => setToolTipView(true)}
                                onTouchEnd={() => setToolTipView(false)}
                            >
                                I would like to enable auto wallet reload.
                                
                                <TooltipView
                                text={
                                    userNRBookings.length > 0 && props.isAutoPayEnabled ?
                                    <span>
                                        Auto pay can be disabled once bookings are completed.
                                    </span>
                                        :
                                    <span>
                                        By enabling auto pay, we ensure that your wallet balance is always maintained at $5.
                                    </span>
                                }
                                clsName={"profileFormStyle"}
                            />
                            </label> */}

            {/* {toolTipView && userNRBookings.length>0 && autoPay&& 
                                <Tooltip
                                    placement="right"
                                    title={"You can disablae auto pay once bookings are completed."}
                                    color="#fff"
                                    visible={true}
                                    overlayInnerStyle={{ color: '#000' }}
                            >
                                
                            </Tooltip>} */}
            {/* </div> */}

            {(props.type === "User" ||
              (props.type === "Customer" && props.access.timeline)) && (
              <div className="mb-3">
                <label className="form-label">Location Codes</label>
                <div>
                  {location.map((apt) =>
                    apt.codeId ? (
                      <div
                        key={apt.codeId}
                        className="input-group flex-nowrap mb-2 input-group-sm"
                      >
                        <div className="input-group-text">
                          <Tooltip
                            title={apt?.subLocationType === "CONDO" ? `Can't set "${apt.locationName}" as the default location` : `Set "${apt.locationName}" as the default location`}
                          >
                            
                            <input
                              checked={apt._id === defaultLocation}
                              type="radio"
                              name="defaultLocation"
                              aria-label="Radio button for following text input"
                              value={apt._id}
                              onChange={() => setDefaultLocation(apt._id)}
                              disabled={apt?.subLocationType === "CONDO" ? true : false}
                            />
                          </Tooltip>
                        </div>
                        <span className="form-control">{apt.locationName}</span>
                        {/* <span className="input-group-text d-none d-md-block">
                          {apt.codeId}
                        </span> */}
                        <button
                          className="btn btn-outline-danger"
                          onClick={() => handleRemoveLocation(apt._id)}
                          type="button"
                        >
                          Remove
                        </button>
                      </div>
                    ) : null,
                  )}

                  <div className="input-group flex-nowrap mb-2">
                    <input
                      type="text"
                      name="locationCode"
                      className="form-control"
                      placeholder="ABCDEF"
                      value={locationCode}
                      onChange={(e) => {
                        setLocationCode(e.target.value.toUpperCase());
                      }}
                    />
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => addLocation()}
                      type="button"
                    >
                      Add
                    </button>
                    <Tooltip title="Scan location QR code">
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => setShowQRScanner(true)}
                        type="button"
                      >
                        <MdOutlineQrCodeScanner />
                      </button>
                    </Tooltip>
                  </div>
                  {isCheckingScannedCode && (
                    <div className="text-muted small mb-2">
                      <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      {isRedirectingToThirdParty ? 'Redirecting...' : 'Checking location code...'}
                    </div>
                  )}
                  {companyOptions.length > 0 && (
                    <div className="mb-2">
                      <label className="form-label">Company</label>
                      <select
                        name="company"
                        className="form-select"
                        value={companyOptions.includes(company) ? company : ""}
                        onChange={(e) => setCompany(e.target.value)}
                      >
                        <option value="" disabled>
                          Select your company
                        </option>
                        {companyOptions.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
                <QRCodeScanner
                  open={showQRScanner}
                  onClose={() => setShowQRScanner(false)}
                  onScan={handleQRScan}
                  title="Scan Location QR Code"
                />
              </div>
            )}

            <div className="mb-3">
              <label className="form-label">Time Format</label>
              <select
                required
                name="timeFormatAmPm"
                className="form-select"
                defaultValue={props.timeFormatAmPm ? "am_pm" : "24"}
              >
                <option value="24">24-hour</option>
                <option value="am_pm">AM/PM</option>
              </select>
            </div>

            <ButtonCustom
              isLoading={isLoading}
              disabled={isLoading}
              type="submit"
              text={"Save"}
            />
          </form>
        </div>
        <div className="container mb-5 mb-md-6 mt-5 user-profile ">
          <div className="mb-3 connector-select-div">
            <div className="select-connector-label">
              Choose your preferred connector
            </div>
            {/* <div className='select-connector-div'>
                            

                            <Select
                                placeholder="Choose your preferred connector"
                                value={userPreferredConnector.l2 ? { value: userPreferredConnector.l2 + '/' + userPreferredConnector.l3, label: userPreferredConnector.l2 + '/' + (userPreferredConnector.l3 == "NACS" ? "Tesla" : userPreferredConnector.l3) } : null} 
                                options={[
                                    { value: 'J1772/CCS1', label: 'J1772/CCS1' },
                                    { value: 'NACS/NACS', label: 'NACS/Tesla' }, 
                                    { value: null, label: 'No Preference' }
                                ]}
                                onChange={(value) => {
                                    if(value){
                                        setUserPreferredConnector({ l2: value.split('/')[0], l3: value.split('/')[1] });
                                    }else{
                                        setUserPreferredConnector({ l2: null, l3: null });
                                    }
                                }}
                            />
                        </div> */}
            <div className="select-connector-div">
              <Radio.Group
                onChange={(e) => {
                  if (e.target.value) {
                    setUserPreferredConnector({
                      l2: e.target.value.split("/")[0],
                      l3: e.target.value.split("/")[1],
                    });
                  } else {
                    setUserPreferredConnector({ l2: null, l3: null });
                  }
                  setPrefConnectorConfirmation(true);
                }}
                value={
                  userPreferredConnector.l2
                    ? userPreferredConnector.l2 +
                      "/" +
                      userPreferredConnector.l3
                    : null
                }
              >
                {/* // defaultValue={JSON.stringify(chargerDynamicRate[i].applicableDays) === JSON.stringify([1, 0, 0, 0, 0, 0, 1])? 'weekends': JSON.stringify(chargerDynamicRate[i].applicableDays) === JSON.stringify([0, 1, 1, 1, 1, 0, 0])? 'weekdays':'' } */}
                <div className="radio-button-div">
                  <div className="connector-radio-button-div">
                    <Radio value="J1772/CCS1">
                      <div className="connector-radio-option-div">
                        <Image
                          src={J1772_IMAGE}
                          alt="J1772/CCS1"
                          width={120}
                          height={100}
                          preview={false}
                        />
                        <p>CCS1 or J1772</p>
                      </div>
                    </Radio>
                  </div>
                  <div className="connector-radio-button-div">
                    <Radio value="NACS/NACS">
                      <div className="connector-radio-option-div">
                        <Image
                          src={NACS_IMAGE}
                          alt="NACS/NACS"
                          width={120}
                          height={100}
                          preview={false}
                        />
                        <p>NACS or Tesla</p>
                      </div>
                    </Radio>
                  </div>
                  <div className="connector-radio-button-div-no-pref">
                    <Radio value={null}>
                      <div className="connector-radio-option-div">
                        {/* <Image src={J1772_IMAGE} alt="J1772/CCS1" width={180} height={100} preview={false} /> */}
                        <p>No preference or have an adapter</p>
                      </div>
                    </Radio>
                    <div className="adapter-links-container">
                      <h6 className="adapter-links-heading">
                        Recommended Adapters for L2 chargers
                      </h6>
                      <ul className="adapter-links-list">
                        <li>
                          <a
                            href="https://a.co/d/0dS1nlwN"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            J1772 to NACS Adapter
                          </a>
                          <span> (vehicle port - NACS)</span>
                        </li>
                        <li>
                          <a
                            href="https://a.co/d/04V8lIwm"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            NACS to J1772 Adapter
                          </a>
                          <span> (vehicle port - J1772)</span>
                        </li>
                      </ul>
                      <span>
                        * In case your vehicle did not come with an adapter
                      </span>
                    </div>
                  </div>
                </div>
              </Radio.Group>
            </div>
          </div>
        </div>

        <div className="container mb-5 mb-md-6 mt-5 user-profile ">
          <div className="auto-pay-section">
            {autoPayAmountAlert && (
              <div className="alert-div">
                {" "}
                <Alert
                  message="Unable to change Auto reload setting, please try again"
                  type="error"
                  showIcon
                  closable
                  onClose={() => setAutoPayAmountAlert(false)}
                />
              </div>
            )}
            <div className="auto-pay-header">
              <span className="auto-pay-header-text">Auto Reload</span>
              <span className="auto-pay-header-switch">
                <Switch
                  checkedChildren="enabled"
                  unCheckedChildren="disabled"
                  checked={autoPay}
                  disabled={userNRBookings.length > 0 && props.isAutoPayEnabled}
                  onChange={(e) => {
                    handleAutoReloadChange(e);
                  }}
                />
              </span>
            </div>
            <div className="auto-pay-content">
              <div className="auto-pay-text">
                Keep your account ready for use with Auto reload. When your
                wallet balance drops below $5, we automatically reload to wallet
                max amount.
              </div>
              {/* <div className='enable-auto-pay-section'>
                                
                                <label
                                    className="form-check-label"
                                    htmlFor="flexCheckPayment"
                                    onMouseEnter={() => setToolTipView(true)}
                                    onMouseLeave={() => setToolTipView(false)}
                                    onTouchStart={() => setToolTipView(true)}
                                    onTouchEnd={() => setToolTipView(false)}
                                >
                                    <input
                                    checked={autoPay} name='auto_reload'
                                    onChange={(e) => handleAutoReloadChange(e)}
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckPayment"
                                    disabled={userNRBookings.length > 0 && props.isAutoPayEnabled}
                                />
                                    I would like to enable auto wallet reload.

                                    <TooltipView
                                        text={
                                            userNRBookings.length > 0 && props.isAutoPayEnabled ?
                                                <span>
                                                    Auto pay can be disabled once bookings are completed.
                                                </span>
                                                :
                                                <span>
                                                    By enabling auto pay, we ensure that your wallet balance is always maintained at $5.
                                                </span>
                                        }
                                        clsName={"profileFormStyle"}
                                    />
                                </label>
                            </div> */}
            </div>
            {autoPay && (
              <>
                {/* <div className='auto-pay-amount-selection-header'>
                                    Select Auto Pay Amount
                                </div> */}
                <div className="auto-pay-amount-selection">
                  {/* {tagsData.map(tag => {
                                        let isLoadingTag = amountLoader && (tag === loadingTag);
                                        return(
                                            <span
                                            disabled={amountLoader || tag === selectedTags}
                                            key={tag}
                                            className={`auto-pay-amount-tag ${(selectedTags === tag) ? 'selected-tag' : ''}`}
                                            onClick={(e) => {handleChange(tag, true); setLoadingTag(tag)}}>
                                            {(isLoadingTag) ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "$" + tag}
                                            
                                        </span>
                                        )
                                        
                                    })} */}
                  {tagsData.map((tag) => {
                    // 1. Determine if THIS specific tag is the one loading
                    const isThisTagLoading = amountLoader && tag === loadingTag;
                    const isSelected = selectedTags === tag;

                    return (
                      <span
                        key={tag}
                        // Use CSS to handle the 'disabled' look/feel since spans don't have a native disabled attr
                        className={`auto-pay-amount-tag ${isSelected ? "selected-tag" : ""} ${amountLoader ? "disabled-tag" : ""}`}
                        style={{
                          pointerEvents: amountLoader ? "none" : "auto",
                          opacity: amountLoader && !isThisTagLoading ? 0.6 : 1,
                        }}
                        onClick={(e) => {
                          if (!amountLoader) {
                            setLoadingTag(tag); // Track which tag was clicked
                            // handleChange(tag, true);
                            setTopUpAmountChangeConfirmation(true);
                          }
                        }}
                      >
                        {isThisTagLoading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          `$${tag}`
                        )}
                      </span>
                    );
                  })}
                </div>
              </>
            )}
          </div>

          {prefConnectorConfirmation && (
            <Modal
              title="Confirm Preferred Connector"
              open={prefConnectorConfirmation}
              onOk={async () => {
                console.log("confirming preferred connector change");
                setIsLoading(true);
                setPrefConnectorConfirmation(false);
                setUserPreferredConnector({
                  l2: userPreferredConnector.l2,
                  l3: userPreferredConnector.l3,
                });
                try {
                  const res = await BreathAPIs.updateProfile({
                    "preferredConnector.l2": userPreferredConnector.l2,
                    "preferredConnector.l3": userPreferredConnector.l3,
                  });
                  if (res) {
                    if (res.data.success) {
                      toast.success(
                        "Connector preference updated successfully",
                      );
                      store.dispatch(loadUser());
                    } else {
                      toast.error(res.data.message);
                    }
                    setIsLoading(false);
                  }
                  setIsLoading(false);
                } catch (error) {
                  console.log("error updating preferred connector: ", error);
                  setIsLoading(false);
                }
              }}
              okText={
                isLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  "Confirm"
                )
              }
              onCancel={() => {
                setUserPreferredConnector({
                  l2: props.userPreferredConnector.l2,
                  l3: props.userPreferredConnector.l3,
                });
                setPrefConnectorConfirmation(false);
              }}
            >
              {console.log(
                "rendering modal with userPreferredConnector: ",
                userPreferredConnector,
              )}
              {userPreferredConnector.l2 === null ||
              userPreferredConnector.l3 === null ? (
                <p>
                  Are you sure you want to remove your preferred connector and
                  have no preference?
                </p>
              ) : (
                <p>
                  Are you sure you want to set {userPreferredConnector.l2}{" "}
                  {userPreferredConnector.l2 !== userPreferredConnector.l3
                    ? `and ${userPreferredConnector.l3} as your preferred connectors?`
                    : "as your preferred connector?"}{" "}
                </p>
              )}
            </Modal>
          )}
        </div>

        {topUpAmountChangeConfirmation && (
          <Modal
            title="Confirm Auto reload Update"
            open={topUpAmountChangeConfirmation}
            onOk={() => {
              setTopUpAmountChangeConfirmation(false);
              handleChange(loadingTag, true);
            }}
            okText="Update"
            onCancel={() => {
              setTopUpAmountChangeConfirmation(false);
              setLoadingTag(null);
            }}
          >
            <p>
              Auto reload top-up amount will be updated to ${loadingTag}. This
              change will apply to your next automatic reload.
            </p>
          </Modal>
        )}

        {disableAutoPayConfirmation && (
          <Modal
            title="Confirmation"
            open={disableAutoPayConfirmation}
            onOk={() => {
              handleDisableAutoPay();
              setDisableAutoPayConfirmation(false);
            }}
            okText="Disable"
            onCancel={() => {
              setDisableAutoPayConfirmation(false);
              setLoadingTag(null);
            }}
          >
            <p>Are you sure you want to disable auto reload?</p>
          </Modal>
        )}

        {removeLocationConfirmation && (
          <Modal
            title="Remove Location"
            open={!!removeLocationConfirmation}
            onOk={() => {
              handleRemoveLocation(removeLocationConfirmation.locationId, true);
              setRemoveLocationConfirmation(null);
            }}
            okText="Remove"
            okButtonProps={{ danger: true }}
            onCancel={() => setRemoveLocationConfirmation(null)}
          >
            <p>
              Removing "{removeLocationConfirmation.parentName}" will also
              remove the following sub-locations:
            </p>
            <ul>
              {removeLocationConfirmation.childNames.map((name) => (
                <li key={name}>{name}</li>
              ))}
            </ul>
            <p>Do you want to continue?</p>
          </Modal>
        )}
        {showRfidRegUI && (
          <div className="container mb-5 mb-md-6 mt-5 user-profile">
            <div className="rfid-registration-div">
              {showTimeoutWarning && (
                <div className="alert-div">
                  {" "}
                  <Alert
                    message="Registration process has timed out please try again."
                    type="warning"
                    showIcon
                    closable
                    onClose={() => setShowTimeoutWarning(false)}
                  />
                </div>
              )}
              {showActiveIdTag && (
                <div className="alert-div">
                  {" "}
                  <Alert
                    message="RFID Tag has been activated successfully."
                    type="success"
                    showIcon
                    closable
                    onClose={() => setShowActiveIdTag(false)}
                  />
                </div>
              )}
              <div>
                <div className="rfid-header">
                  <h5 className="rfid-header-text">RFID</h5>
                  {!(
                    isRfidRegModelOpen ||
                    rfidSelectedLocation ||
                    rfidSelectedCharger
                  ) && (
                    <Button
                      disabled={
                        isRfidRegModelOpen ||
                        rfidSelectedLocation ||
                        rfidSelectedCharger
                      }
                      onClick={() => {
                        setIsRfidRegModelOpen(true);
                      }}
                      className="add-rfid-btn"
                    >
                      + Add New
                    </Button>
                  )}

                  {(isRfidRegModelOpen ||
                    rfidSelectedLocation ||
                    rfidSelectedCharger) &&
                    rfidRegStatus.status !== "verification-pending" && (
                      <Button
                        onClick={() => {
                          setIsRfidRegModelOpen(false);
                          setRfidSelectedLocation(null);
                          setRfidSelectedCharger(null);
                          setRfidRegStatus({ status: null, message: null });
                          updateRfidRegInCharger("removeUser");
                          // give be call to clear all data
                        }}
                        className="cancel-rfid-btn"
                      >
                        Cancel
                      </Button>
                    )}
                </div>

                {isRfidRegModelOpen && (
                  <div>
                    <div className="location-selection-text-rfid">
                      Please select a location and charger to register a new
                      RFID
                    </div>
                    <div className={"rfid-form-div"}>
                      <Select
                        showSearch
                        value={rfidSelectedLocation}
                        onChange={(value) => {
                          setRfidSelectedLocation(value);
                        }}
                        placeholder={"Select Location"}
                        style={{ width: "100%" }}
                        options={props.location.map((element) => ({
                          value: element._id,
                          label: element.locationName,
                        }))}
                        filterOption={
                          (input, option) =>
                            option.label
                              .toLowerCase()
                              .includes(input.toLowerCase()) // Custom filtering logic
                        }
                      ></Select>

                      <Select
                        disabled={
                          rfidSelectedLocation === null ||
                          rfidLocationChargers.length === 0
                        }
                        showSearch
                        value={rfidSelectedCharger}
                        onChange={(value) => {
                          setRfidSelectedCharger(value);
                        }}
                        placeholder={"Select Charger"}
                        style={{ width: "100%" }}
                        options={rfidLocationChargers.map((element) => ({
                          value: element._id,
                          label: element.chargerTag,
                        }))}
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      ></Select>

                      <Button
                        disabled={!rfidSelectedLocation || !rfidSelectedCharger}
                        onClick={() => {
                          updateRfidRegInCharger();
                        }}
                      >
                        Continue
                      </Button>
                    </div>
                    {rfidLocationChargers.length === 0 &&
                      !rfidLoading.locationChargersLoading &&
                      rfidSelectedLocation && <p>* No Chargers Available </p>}
                  </div>
                )}

                {rfidLoading.stepsLoading && (
                  <div className="rfid-status-div">
                    <div className="title-bar-style"></div>

                    <div className="text-bar-style"></div>
                  </div>
                )}

                {rfidRegStatus.status && !rfidLoading.stepsLoading && (
                  <div>
                    {rfidRegStatus.status === "pre-auth" ? (
                      <div className="rfid-status-div">
                        <span>Step 1</span>
                        <p>Please tap your RFID card on the charger</p>
                      </div>
                    ) : rfidRegStatus.status === "verification-pending" ? (
                      <div className="rfid-status-div">
                        <span>Step 2</span>
                        <p>
                          Please tap same RFID card once again to complete
                          activation
                        </p>
                      </div>
                    ) : rfidRegStatus.status === "active" ? (
                      <div className="rfid-status-div">
                        <span>Step 3(Optional)</span>
                        <p className="rfid-nameinput-info">Enter Tag name</p>
                        <div className="rfid-nameinput-div">
                          <Input
                            type="text"
                            placeholder="Enter tag name (optional)"
                            value={editRfid.idTagName}
                            onChange={(e) => {
                              setEditRfid({
                                idTag: null,
                                idTagName: e.target.value,
                                isModelOpen: false,
                              });
                            }}
                          />
                          <Button
                            onClick={() => {
                              updateUserRfid(null, editRfid.idTagName);
                              setShowRfidNameInput(false);
                              setRfidRegStatus({
                                status: null,
                                message: null,
                              });
                            }}
                          >
                            {rfidLoading.rfidEditLoading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "Continue"
                            )}
                          </Button>
                        </div>
                      </div>
                    ) : rfidRegStatus.status === "time-out" ? (
                      <div className="rfid-status-div">
                        <span>Time Out</span>
                        <p>Please try again</p>
                      </div>
                    ) : rfidRegStatus.status === "invalid-card" ? (
                      <div className="rfid-status-div">
                        <span>Invalid Card</span>
                        <p>
                          Looks like you tapped a wrong card, please use the
                          same RFID card
                        </p>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                )}

                <div className="active-idtags-div">
                  {(isRfidRegModelOpen ||
                    rfidSelectedLocation ||
                    rfidSelectedCharger) &&
                    userActiveIdTags.length > 0 && <h6>Active RFID Tags</h6>}
                  {userActiveIdTags.map((tag) => {
                    if (tag.idTagStatus == "active") {
                      return (
                        <div>
                          <div
                            key={tag.idTag}
                            className="input-group flex-nowrap mb-2 input-group-sm"
                          >
                            <div className="input-group-text">
                              <Tooltip
                                title={
                                  <div>
                                    Tag Name: {tag.idTagName}
                                    <br />
                                    Tag ID: {tag.idTag}
                                  </div>
                                }
                              >
                                <IoEyeOutline></IoEyeOutline>
                              </Tooltip>
                            </div>
                            <span className="form-control">
                              {tag.idTagName}
                            </span>
                            <span className="form-control-buttons-span">
                              <button
                                className="btn btn-outline-primary edit-rfid-btn"
                                onClick={() =>
                                  setEditRfid({
                                    idTag: tag.idTag,
                                    idTagName: tag.idTagName,
                                    isModelOpen: true,
                                  })
                                }
                              >
                                <CiEdit></CiEdit>
                              </button>
                              <button
                                className="btn btn-outline-danger delete-rfid-btn"
                                onClick={() =>
                                  setDeleteRfid({
                                    idTag: tag.idTag,
                                    idTagName: tag.idTagName,
                                    isModelOpen: true,
                                  })
                                }
                              >
                                <AiOutlineDelete></AiOutlineDelete>
                              </button>
                            </span>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* {<div className='user-profile'>
                    <div>
                    <h4>
                    Need help ?
                    </h4>
                    Head over to our User Guide for easy-to-follow instructions, illustrative screenshots, and solutions to frequently asked questions

                         </div>
                    <div >
                        <Button type='link' onClick={()=>{navigate('/userguide')}} className='userguide-button' icon={<FaExternalLinkAlt/>}>
                        View User Guide
                        </Button>
                    </div>

                </div>} */}

         <div className="version-footer-text">
          Web App {latestVersions.webApp || "N/A"}{" "}
          <span className="version-footer-separator">&sdot;</span> CSMS{" "}
          {latestVersions.csms || "N/A"}
        </div>
      </div>

      {editRfid.isModelOpen && (
        <Modal
          open={editRfid.isModelOpen}
          onCancel={() => {
            setEditRfid({ idTag: null, idTagName: "", isModelOpen: false });
          }}
          okText={
            rfidLoading.rfidEditLoading ? (
              <div style={{ width: "45px" }}>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              "Update"
            )
          }
          cancelText="Cancel"
          onOk={() => {
            updateUserRfid(editRfid.idTag, editRfid.idTagName);
            // setEditRfid({idTag: null, idTagName: "",isModelOpen: false});
          }}
        >
          <div>
            <div>
              <p>
                Enter new tag name for{" "}
                <span>
                  {editRfid.idTag ? editRfid.idTag : "your newly added RFID"}
                </span>
              </p>
              <p className="tag-name-help-text">
                Tag name helps you to organize your RFID tags
              </p>
            </div>
            <div>
              <div>
                <Input
                  type="text"
                  placeholder="New tag name"
                  value={editRfid.idTagName}
                  onChange={(e) => {
                    setEditRfid({
                      idTag: editRfid.idTag,
                      idTagName: e.target.value,
                      isModelOpen: true,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
      {deleteRfid.isModelOpen && (
        <Modal
          open={deleteRfid.isModelOpen}
          onCancel={() => {
            setDeleteRfid({ idTag: null, idTagName: "", isModelOpen: false });
          }}
          okText={
            rfidLoading.rfidDeleteLoading ? (
              <div style={{ width: "45px" }}>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              "Delete"
            )
          }
          cancelText="Cancel"
          onOk={() => {
            deleteUserRfid(deleteRfid.idTag);
            setDeleteRfid({ idTag: null, idTagName: "", isModelOpen: false });
          }}
        >
          <div className={"delete-rfid-form-div"}>
            <p>Are you sure you wan't to delete the RFID tag</p>
            <span>
              {" "}
              {deleteRfid.idTag}{" "}
              {deleteRfid.idTagName ? ": " + deleteRfid.idTagName : ""}
            </span>
          </div>
        </Modal>
      )}
      {paymentModal && (
        <Modal
          open={paymentModal}
          footer={null}
          onCancel={() => {
            setPaymentModal(false);
            setAutopay(props.isAutoPayEnabled);
            togglePanel("1");
          }}
        >
          <>
            {noOfMethods === 0 ? (
              <div>
                {/* <StripePayment setPaymentModal={setPaymentModal}></StripePayment> */}
                <CardPaymentForm
                  setPaymentModal={setPaymentModal}
                  noOfMethods={noOfMethods}
                  autopayThreshold={selectedTags}
                ></CardPaymentForm>
              </div>
            ) : (
              <>
                {
                  <>
                    <div className={"paymentContainer"}>
                      <div className="accordion" id="accordionExample">
                        {/* Accordion Item 1 */}
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className={`accordion-button ${activeKey === "1" ? "" : "collapsed"}`}
                              type="button"
                              onClick={() => togglePanel("1")}
                              aria-expanded={activeKey === "1"}
                              aria-controls="collapseOne"
                            >
                              Select a payment method
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className={`accordion-collapse collapse ${activeKey === "1" ? "show" : ""}`}
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              {methodList.map((m) => {
                                return selectedCard === m.id ? (
                                  <CardBlock
                                    key={m.id}
                                    type={m.card.brand}
                                    number={m.card.last4}
                                    expiry={`${m.card.exp_month}/${m.card.exp_year}`}
                                    id={m.id}
                                    wallet={m.card.wallet}
                                    selected
                                  ></CardBlock>
                                ) : (
                                  <CardBlock
                                    key={m.card.id}
                                    type={m.card.brand}
                                    number={m.card.last4}
                                    expiry={`${m.card.exp_month}/${m.card.exp_year}`}
                                    id={m.card.id}
                                    onClick={() => {
                                      setSelectedCard(m.id);
                                      setSelectedCardDetails(m);
                                    }}
                                    wallet={m.card.wallet}
                                  ></CardBlock>
                                );
                                // <div>{m.card.brand} {m.card.last4}</div>
                              })}

                              <ButtonCustom
                                text={"Enable"}
                                style={{ width: "100%", "margin-top": "34px" }}
                                onClick={() => {
                                  sendPaymentIntent(selectedCard);
                                }}
                                isLoading={isLoading}
                              ></ButtonCustom>
                            </div>
                          </div>
                        </div>

                        {/* Accordion Item 2 */}
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className={`accordion-button ${activeKey === "2" ? "" : "collapsed"}`}
                              type="button"
                              onClick={() => togglePanel("2")}
                              aria-expanded={activeKey === "2"}
                              aria-controls="collapseTwo"
                            >
                              Add new payment method
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            className={`accordion-collapse collapse ${activeKey === "2" ? "show" : ""}`}
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div>
                                <CardPaymentForm
                                  setPaymentModal={setPaymentModal}
                                  noOfMethods={noOfMethods}
                                  autopayThreshold={selectedTags}
                                ></CardPaymentForm>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Accordion Item 3 */}
                      </div>
                    </div>
                  </>
                }
              </>
            )}
            {autoPay && (
              <>
                {/* <div className='auto-pay-amount-selection-header'>
                                    Select Auto Pay Amount
                                </div> */}
                <div className="auto-pay-from-div">
                  <p>Select wallet max amount</p>
                  <div className="auto-pay-amount-selection-payment-form">
                    {tagsData.map((tag) => {
                      // 1. Determine if THIS specific tag is the one loading
                      const isThisTagLoading =
                        amountLoader && tag === loadingTag;
                      const isSelected = selectedTags === tag;

                      return (
                        <span
                          key={tag}
                          // Use CSS to handle the 'disabled' look/feel since spans don't have a native disabled attr
                          className={`auto-pay-amount-tag ${isSelected ? "selected-tag" : ""} ${amountLoader ? "disabled-tag" : ""}`}
                          style={{
                            pointerEvents: amountLoader ? "none" : "auto",
                            opacity:
                              amountLoader && !isThisTagLoading ? 0.6 : 1,
                          }}
                          onClick={(e) => {
                            if (!amountLoader) {
                              setLoadingTag(tag); // Track which tag was clicked
                              // handleChange(tag, true);
                              // setTopUpAmountChangeConfirmation(true)
                              // setTopUpAmountChangeConfirmation(false);
                              handleChange(tag, true);
                            }
                          }}
                        >
                          {isThisTagLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            `$${tag}`
                          )}
                        </span>
                      );
                    })}
                  </div>
                </div>
              </>
            )}
          </>
        </Modal>
      )}
    </div>
  );
};

UserProfile.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  receive_sms_updates: PropTypes.bool,
  receive_promotional_messages: PropTypes.bool,
  isPhoneVerified: PropTypes.bool,
  userID: PropTypes.string,
  isGuest: PropTypes.bool,
  location: PropTypes.any,
  type: PropTypes.string,
  timeFormatAmPm: PropTypes.bool,
  defaultLocation: PropTypes.string,
  access: PropTypes.object,
  jwt: PropTypes.string,
  isAutoPayEnabled: PropTypes.bool,
  selectedPaymentMethod: PropTypes.string,
  stripeCustomerId: PropTypes.string,
  walletCoins: PropTypes.number,
  userTags: PropTypes.array,
  autoPayThreshold: PropTypes.number,
  availableNightChargeCount: PropTypes.number,
  userPreferredConnector: PropTypes.object,
};
const mapStateToProps = (state) => ({
  firstName: state.auth && state.auth.user ? state.auth.user.firstName : null,
  lastName: state.auth && state.auth.user ? state.auth.user.lastName : null,
  email: state.auth && state.auth.user ? state.auth.user.email : null,
  phone: state.auth && state.auth.user ? state.auth.user.phone : null,
  receive_sms_updates:
    state.auth && state.auth.user ? state.auth.user.receive_sms_updates : false,
  receive_promotional_messages:
    state.auth && state.auth.user
      ? state.auth.user.receive_promotional_messages
      : false,
  isPhoneVerified:
    state.auth && state.auth.user ? state.auth.user.isPhoneVerified : false,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  isGuest: state.auth && state.auth.user ? state.auth.user.isGuest : false,
  location: state.auth && state.auth.user ? state.auth.user.location : null,
  type: state.auth && state.auth.user ? state.auth.user.type : null,
  timeFormatAmPm:
    state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
  defaultLocation:
    state.auth && state.auth.user ? state.auth.user.defaultLocation : null,
  jwt: state.auth ? state.auth.token : null,
  access: state.auth && state.auth.user ? state.auth.user.access : null,
  isAutoPayEnabled:
    state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
  selectedPayment:
    state.auth && state.auth.user ? state.auth.user.selectedPaymentMethod : "",
  stripeCustomerId:
    state.auth && state.auth.user ? state.auth.user.stripeCustomerId : "",
  walletCoins:
    state.auth && state.auth.user ? state.auth.user.wallet.coins : "",
  userTags: state.auth && state.auth.user ? state.auth.user.userTags : null,
  autoPayThreshold:
    state.auth && state.auth.user ? state.auth.user.autoPayThreshold : null,
  availableNightChargeCount:
    state.auth && state.auth.user ? state.auth.user.availableNightCharging : 0,
  userPreferredConnector:
    state.auth && state.auth.user ? state.auth.user.preferredConnector : null,
});

export default connect(mapStateToProps, {})(UserProfile);
